import api from './api';

const URLS = {
  findValidPromoCodeDataByCode: 'findValidPromoCodeDataByCode',
};

export const findValidPromoCodeDataByCode = (body) => {
  return api.post(URLS.findValidPromoCodeDataByCode, body);
};
